import { cn } from '@/lib/cn';
import { SportIcon, type SportIconName } from '@/ui/common';

export interface SearchCategoryItemProps {
  label: string;
  sportIconName: SportIconName;
  onSelect?: () => void;
  className?: string;
}

export function SearchCategoryItem({
  label,
  sportIconName,
  onSelect,
  className,
}: SearchCategoryItemProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        'flex h-10 w-full items-center gap-2 bg-bg-surface px-3 py-2 text-left',
        'hover:bg-bg-elevated focus-visible:bg-bg-elevated focus-visible:outline-none',
        className,
      )}
    >
      <SportIcon name={sportIconName} size={20} className="shrink-0" />
      <span className="min-w-0 flex-1 truncate text-[13px] text-text-primary">{label}</span>
    </button>
  );
}
